module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('nav', {
    staticClass: "header__nav"
  }, [_c('img', {
    staticClass: "header__img",
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "src": require("../../../static/images/logo_hh.png"),
      "alt": "logo"
    },
    on: {
      "click": _vm.goToIndex
    }
  }), _vm._v(" "), _c('img', {
    class: this.$route.query.yanse == 1 ? 'header__img2' : 'header__img',
    staticStyle: {
      "padding-left": "15px",
      "height": "45px"
    },
    attrs: {
      "src": require("../../../static/images/logo_ryy.png"),
      "alt": "logo"
    },
    on: {
      "click": _vm.goToIndex
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header__info"
  }, [_c('p', {
    staticClass: "header__tel"
  }, [_vm._v(_vm._s(_vm.companyInfo.tel))]), _vm._v(" "), _c('p', {
    staticClass: "header__open-time"
  }, [_vm._v("9:00 - 17:30")])]), _vm._v(" "), _c('div', {
    staticClass: "header__links"
  }, [_c('router-link', {
    staticClass: "header__link",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('router-link', {
    class: ['header__link', _vm.$route.meta.name === 'myLoan_bl' && _vm.$route.path == '/products/' ? 'active' : ''],
    attrs: {
      "to": {
        path: '/products/',
        query: {
          customerType: 1,
          categoryCode: 1003
        }
      }
    }
  }, [_vm._v("\n       我要申请")]), _vm._v(" "), _c('router-link', {
    class: ['header__link', _vm.$route.meta.name === 'myLoan_bl' ? 'active' : ''],
    attrs: {
      "to": "/personalCenter/myLoan_bl/loanLists_bl?frontApplyState=0&pageCount=1&applyState=all",
      "exact": ""
    }
  }, [_vm._v("我的保理\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "header__link",
    attrs: {
      "to": "/aboutUs",
      "exact": ""
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), (_vm.isLogin) ? [_c('div', {
    staticClass: "header__user"
  }, [_c('router-link', {
    staticClass: "header__user--tel",
    attrs: {
      "to": "/personalCenter/myLoan_bl/loanLists_bl"
    }
  }, [_vm._v(_vm._s(_vm._f("encryptCellphone")(_vm.userInfo.crmCustomerLoginName)) + "\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "header__link",
    class: this.$store.state[1].msgNum > 0 ? 'headerBox' : '',
    attrs: {
      "to": "/personalCenter/message"
    }
  }, [_c('i', {
    staticClass: "el-icon-message"
  }, [_c('span', {
    staticClass: "mesnum"
  }, [_vm._v("(" + _vm._s(this.$store.state[1].msgNum) + ")")])])]), _vm._v(" "), _c('a', {
    staticClass: "header__logout",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)] : [_c('div', {
    staticClass: "header__user"
  }, [_c('router-link', {
    staticClass: "header__login",
    attrs: {
      "to": "/login",
      "exact": ""
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('router-link', {
    staticClass: "header__register",
    attrs: {
      "to": "/register",
      "exact": ""
    }
  }, [_vm._v("注册")])], 1)]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ca8624e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header.vue
// module id = 1081
// module chunks = 1